// w13.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W13 = () => {
  return <WW config={pageConfigs.w13} />;
};

export default W13;
